// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"c17b910c","455":"6bc9f45e","593":"bf046a1e","596":"896baf50","977":"0296d865"}[chunkId] + ".chunk.js";
};